import { Select } from "../modules/select";

const selects = document.querySelectorAll(".form-select");


if (selects.length > 0) {
    selects.forEach(select => {
        const selectClass = new Select(select)
    });
}